import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1d09e790")

_pushScopeId("data-v-1d09e790")
const _hoisted_1 = {
  class: "toc_ui__baseInfo_main",
  id: "BaseInfo"
}
const _hoisted_2 = { class: "toc_ui__baseInfo_body" }
const _hoisted_3 = { class: "toc_ui__baseInfo_body_cont" }
const _hoisted_4 = { class: "titleSlot" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_componentTitle = _resolveComponent("componentTitle")
  const _component_infoList = _resolveComponent("infoList")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_componentTitle, { title: "车辆信息" }, {
          default: _withId(() => [
            _createVNode("span", _hoisted_4, "VIN码：" + _toDisplayString(_ctx.state.vinCode), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_infoList, {
          dataList: _ctx.state.dataList,
          direction: ""
        }, null, 8, ["dataList"])
      ])
    ])
  ]))
})